import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { ContainerSx, LinkSx } from './styles';
import { LinkCellProps } from './types';

const LinkCell = (params: any) => {
  const { row, colDef } = params;
  const { field } = colDef;
  const props: LinkCellProps = row[field];
  
  const { 
    text, 
    link, 
    openInNewTab = false,
    bold = false,
    underlined = true,
  } = props;

  if (!text || !link) {
    return <Stack sx={ContainerSx}>{text || 'N/A'}</Stack>;
  }

  return (
    <Stack sx={ContainerSx}>
      <Link 
        href={link}
        target={openInNewTab ? "_blank" : "_self"}
        rel={openInNewTab ? "noopener noreferrer" : undefined}
        sx={LinkSx(bold, underlined)}
      >
        {text}
      </Link>
    </Stack>
  );
};

export default LinkCell; 
